<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="Course-Tab-Module" class="data-list-container">
    <h6 style="color:orange">-{{ $t('MustSelectModule') }}</h6>
    <vs-prompt :title="$t('NewModule')" :accept-text="$t('Save')" :cancel-text="$t('Cancel')" @cancel="clearModule"
      @accept="SaveModule" @close="clearModule" :is-valid="validateModuleForm" :active.sync="activeModulePrompt">
      <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent style="max-height:75vh">
          <div v-if="getCourseModules != null && getCourseModules != undefined && getCourseModules.length > 0">
            <h4 v-if="!(getCourseModules[0].ID > 0)">L{{ $t('LastModuleCode') }}: {{ getCourseModules[0].CourseModuleCode }} 1
            </h4>
            <h4 v-if="(getCourseModules[0].ID > 0)">{{ $t('LastModuleCode') }} : {{ allModules[0].CourseModuleCode }} 2</h4>
          </div>
          <div v-if="!(getCourseModules != null && getCourseModules != undefined && getCourseModules.length > 0)">
            <h4>{{ $t('LastModuleCode') }}: {{ allModules[0].CourseModuleCode }} 3</h4>
          </div>

          <div class="vx-col flex-1">
            <vs-input :label="$t('Name')" v-model="moduleItem.Name" class="w-full" name="Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
          </div>
          <div class="vx-col flex-1 mt-5">
            <vs-input :label="$t('Code')" v-model="moduleItem.CourseModuleCode" class="w-full" name="Code"
              v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Code')">{{ errors.first('Code') }}</span>
          </div>
          <div class="vx-col flex-1  mt-5">
            <vs-input :label="$t('Hours')" v-model="moduleItem.Hours" class="w-full" type="number" name="Hours"
              v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Hours')">{{ errors.first('Hours') }}</span>
          </div>
          <div class="w-full mt-5">
            <label class="vs-input--label">{{ $t('Content') }}</label>
            <quill-editor v-model="moduleItem.ModuleContent" :options="editorOption" />

          </div>
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>


    <vs-prompt :title="$t('ImportModule')" :accept-text="$t('Save')" :cancel-text="$t('Cancel')" @cancel="clearModule"
      @accept="SaveImportModule" @close="clearModule" :active.sync="activeModuleImportPrompt">
      <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent style="max-height:75vh">
          <div class="vx-col flex-1">
            <div class="flex-1" style="padding-left:5px">
              <p>{{ $t('Course') }}</p>
              <v-select label="Name" class=" w-full" v-model="moduleItem.CourseID" :options="courses"
                :reduce="value => value.ID" @input="getModules(moduleItem.CourseID)" />
              <!-- <vs-select class="mt-5 w-full" label="Course" v-model="moduleItem.CourseID" @change="getModules(moduleItem.CourseID)" >
                                      <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in courses" />
                            </vs-select> -->
              <span class="text-danger text-sm" v-show="errors.has('Course')">{{ errors.first('Course') }}</span>
            </div>
            <div class="flex-1 mt-5 " style="padding-left:5px" v-show="moduleItem.CourseID > 0">
              <p>{{ $t('CourseModules') }}</p>
              <v-select label="Name" class="w-full" v-model="moduleItem.CourseModule" :options="courseModules"
                :reduce="value => value" />

              <span class="text-danger text-sm" v-show="errors.has('CourseModules')">{{ errors.first('CourseModules')
              }}</span>
            </div>
          </div>
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>
    <vs-prompt title="New Material" :accept-text="$t('Save')" :cancel-text="$t('Cancel')" @cancel="clearMaterial"
      @accept="SaveMaterial" @close="clearMaterial" :is-valid="validateMaterialForm" :active.sync="activeMaterialPrompt">
      <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent style="max-height:75vh">

          <div class="vx-col flex-1">
            <p>{{ $t('Name') }}</p>
            <vs-input v-model="MaterialItem.Name" class="w-full" name="Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
          </div>
          <div class="vx-col flex-1">
            <br />
            <p>{{ $t('Version') }}</p>
            <vs-input v-model="MaterialItem.Version" class="w-full" name="Version" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Version')">{{ errors.first('Version') }}</span>
          </div>
          <br />
          <p>{{ $t('MaterialType') }}</p>
          <v-select label="Name" class="w-full" v-model="MaterialItem.MaterialTypeID" :options="getMaterialType"
            :reduce="ID => ID.ID" />
          <br />
          <vs-checkbox v-model="MaterialItem.VisiableByTrainee">{{ $t('VisiableByTrainee') }} </vs-checkbox>

          <vs-upload automatic :limit="1" :action="uploadUrl" :headers="UploadRequestHeader"
            @on-success="successUpload" />
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>

    <vs-prompt title="import Module" :active.sync="activeModuleImport">
      <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent style="max-height:75vh">
          <vs-upload automatic :limit="1" accept=".csv" :action="importUrl" :headers="UploadRequestHeader"
            @on-success="successImport" />
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>

    <div slot="no-body" class="tabs-container pb-6">
      <div class="vx-row">
        <div class="vx-col lg:w-2/3 w-full mt-5">
          <div class="vx-row flex-1 w-full" style="padding-left:20px;">
            <div>
              <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus"
                @click="clearModule(); activeModulePrompt = true">{{ $t('Add') }} </vs-button>
            </div>
            <div class="ml-5">
              <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus"
                @click="clearModule(); activeModuleImportPrompt = true"> {{ $t('ImportModule') }} </vs-button>
            </div>
            <div class="ml-5">
              <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus"
                @click="activeModuleImport = true"> CSV </vs-button>
            </div>
          </div>
          <vs-table ref="table" pagination :max-items="itemsPerPage" :data="getCourseModules">
            <template slot="thead">
              <vs-th sort-key="Name">{{ $t('Name') }}</vs-th>

              <vs-th sort-key="Code">{{ $t('Code') }}</vs-th>
              <vs-th sort-key="Code">{{ $t('Hours') }}</vs-th>
              <vs-th>{{ $t('Action') }}</vs-th>
            </template>
            <template slot-scope="{data}">
              <tbody>
                <tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click="viewMaterial(tr)"
                  :style="tr.IsActive ? ' background-color: rgba(var(--vs-primary),1)!important;color:white' : 'background-color: white !important;color:#626262'"
                  style="cursor:pointer">
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ tr.Name }}</p>
                  </vs-td>
                  <vs-td>
                    <p class="product-name font-medium truncate" @click="viewMaterial(tr)">{{ tr.CourseModuleCode }}</p>
                  </vs-td>
                  <vs-td>
                    <p class="product-name font-medium truncate" @click="viewMaterial(tr)">{{ tr.Hours }}</p>
                  </vs-td>
                  <vs-td class="whitespace-no-wrap vx-row">
                    <div class=" vx-row">
                      <vx-tooltip :text="$t('EditModule')" position="top">
                        <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click.stop="editModule(tr)" />
                      </vx-tooltip>
                      <vx-tooltip :text="$t('Delete')" position="top">
                        <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                          @click="openConfirm(tr)" />
                      </vx-tooltip>
                      <vx-tooltip :text="$t('ViewMaterial')" position="top">
                        <feather-icon icon="InfoIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2"
                          @click="viewMaterial(tr)" />
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </tr>
              </tbody>
            </template>
          </vs-table>
        </div>

        <div class="vx-col lg:w-1/3 w-full mt-5">
          <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus" :disabled="moduleIsActive"
            @click="clearMaterial(); activeMaterialPrompt = true">{{ $t('AddMaterial') }} </vs-button>
          <vs-table ref="table" pagination :max-items="itemsPerPage" :data="moduleMaterials">
            <template slot="thead">
              <vs-th sort-key="TrainingAd">{{ $t('Name') }}</vs-th>
              <vs-th sort-key="TrainingAd">{{ $t('Version') }}</vs-th>
              <vs-th sort-key="TrainingAd">{{ $t('VisiableByTrainee') }}</vs-th>
              <vs-th sort-key="Name">{{ $t('Download') }}</vs-th>
              <vs-th>{{ $t('Action') }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ tr.Name }}</p>
                  </vs-td>
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ tr.Version }}</p>
                  </vs-td>
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ tr.VisiableByTrainee }}</p>
                  </vs-td>

                  <vs-td>
                    <a :href="baseUrl + tr.Url" download target="_blank"><feather-icon icon="DownloadIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
                  </vs-td>
                  <vs-td class="whitespace-no-wrap">
                    <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      @click.stop="editMaterial(tr)" />
                    <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                      @click="openConfirm(tr)" />
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>


<script>


import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'

import vSelect from 'vue-select'
import { domain, mainSetting } from '@/gloabelConstant.js'
import moduleCourse from "@/store/course/moduleCourse.js";
import moduleMaterialType from "@/store/settings/materialType/moduleMaterialType.js";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from "@/axios.js"
export default {
  components: {
    vSelect,
    VuePerfectScrollbar,
    quillEditor,
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: toolbar
        },
        placeholder: 'Message'
      },
      UploadRequestHeader: mainSetting.UploadRequestHeader,
      uploadUrl: domain + "API/Course/UploadFile",
      importUrl: domain + "API/Course/ImportModule",
      baseUrl: domain,
      activeModuleImport: false,

      activeModulePrompt: false,
      activeMaterialPrompt: false,
      activeModuleImportPrompt: false,
      selected: [],
      Modules: [],
      itemsPerPage: 5,
      isMounted: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      // Data Sidebar
      courseModel: {},
      moduleMaterials: [],
      rowDataForDelete: {},
      activeConfirm: false,
      moduleItem: {},
      MaterialItem: {},
      moduleIsActive: true,
    };

  },
  computed: {

    courseModules() {
      return this.Modules;
    },
    allModules() {
      debugger
      return this.$store.state.courseList.allModules;
    },
    courses() {

      return this.$store.state.courseList.courses;
    },
    getCourseModules() {
      debugger
      return this.$store.state.courseList.courseModules;
    },

    getMaterialType() {
      return this.$store.state.materialTypeList.materialTypes;
    },


    validateModuleForm() {
      return this.moduleItem.Name != ''
    },

    validateMaterialForm() {
      return this.MaterialItem.Name != '' && this.MaterialItem.MaterialTypeID != undefined
    }
  },

  methods: {

    SaveImportModule() {

      this.moduleItem.CourseModuleMaterials = [];
      this.moduleItem.Name = this.moduleItem.CourseModule.Name;
      this.moduleItem.CourseModuleCode = this.moduleItem.CourseModule.CourseModuleCode;
      this.moduleItem.Hours = this.moduleItem.CourseModule.Hours;
      this.moduleItem.ModuleContent = this.moduleItem.CourseModule.ModuleContent;

      this.moduleItem.CourseModule.CourseModuleMaterials.forEach(element => {
        this.MaterialItem.MaterialTypeID = element.MaterialTypeID;
        this.MaterialItem.Url = element.Url;
        this.MaterialItem.Name = element.Name;
        this.moduleItem.CourseModuleMaterials.unshift(this.MaterialItem);
        this.MaterialItem = {};
      });
      this.moduleItem.CourseModule = null;
      this.SaveModule();
    },
    getModules(id) {

      axios.get("api/Course/GetCourseModulesByCourseID?courseID=" + id)
        .then((response) => {
          this.Modules = response.data;
        })
    },
    successUpload(event) {

      this.MaterialItem.Url = event.target.responseText;
      this.$vs.notify({
        fixed: true,
        color: 'success', title: this.$t("UploadSuccess"),
        text: this.$t("SuccessuploadyourAttachment")
      })
    },
    successImport(event) {
      var items = JSON.parse(event.target.response);

      var vm = this;
      items.forEach(element => vm.$store.commit("courseList/ADD_Module", element))

      this.$vs.notify({
        fixed: true, color: 'success',
        title: this.$t("UploadSuccess"),
        text: this.$t("MouduleImportSuccessfully")
      });
      this.activeModuleImport = false;
    },
    viewMaterial(moduleItem) {
      this.$store.commit("courseList/Clear_ActiveModule");
      this.moduleIsActive = false;
      moduleItem.IsActive = true;

      if (moduleItem.CourseModuleMaterials == undefined)
        moduleItem.CourseModuleMaterials = [];
      this.moduleMaterials = moduleItem.CourseModuleMaterials;
    },
    clearModule() {
      this.moduleItem = {};
    },

    clearMaterial() {
      this.MaterialItem = {};
    },

    editModule(data) {
      this.moduleItem = JSON.parse(JSON.stringify(data));
      this.moduleItem.OldName = this.moduleItem.Name;
      this.activeModulePrompt = true;
    },

    SaveModule() {

      //remove old
      if (this.moduleItem.OldName != undefined)
        this.$store.commit("courseList/REMOVE_Module", this.moduleItem.OldName)

      this.$store.commit("courseList/ADD_Module", this.moduleItem);
      this.clearModule();
    },

    deleteModule(data) {
      if (data.ID != undefined)
        this.$store.dispatch("courseList/removeCourseModule", data);
      this.$store.commit("courseList/REMOVE_Module", data.Name);
    },

    editMaterial(data) {
      this.MaterialItem = JSON.parse(JSON.stringify(data));
      this.MaterialItem.OldName = this.MaterialItem.Name;
      this.activeMaterialPrompt = true;
    },

    SaveMaterial() {
      if (this.MaterialItem.OldName != undefined)
        this.deleteMaterialLocal(this.MaterialItem.OldName)

      this.moduleMaterials.unshift(this.MaterialItem);

      // this.moduleMaterials.unshift(this.MaterialItem);
      //
      // this.$store.commit("courseList/ADD_ModuleMaterial", this.MaterialItem);
      // this.clearModule();
    },

    deleteMaterial(data) {
      if (data.ID != undefined)
        this.$store.dispatch("courseList/removeCourseModuleMaterial", data);
      this.deleteMaterialLocal(data.Name);
    },
    deleteMaterialLocal(materialName) {
      const MaterialIndex = this.moduleMaterials.findIndex((p) => p.Name == materialName)
      if (MaterialIndex != -1)
        this.moduleMaterials.splice(MaterialIndex, 1)
    },

    initValues() {
      this.courseModel = {};
    },

    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord") + "?",
        accept: this.acceptAlert
      });
    },

    acceptAlert() {
      if (this.rowDataForDelete.MaterialTypeID == undefined)
        this.deleteModule(this.rowDataForDelete);
      else
        this.deleteMaterial(this.rowDataForDelete);

      this.$vs.notify({
        fixed: true,
        color: "danger",
        title: this.$t("Deletedrecord"),
        text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },


  },

  created() {
    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
    if (!moduleMaterialType.isRegistered) {
      this.$store.registerModule("materialTypeList", moduleMaterialType);
      moduleMaterialType.isRegistered = true;
    }
    this.$store.dispatch("materialTypeList/fetchDataListItems");
    this.$store.dispatch("courseList/getAllModules");
    this.$store.commit("courseList/Clear_ActiveModule");
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
<style lang="css">
.disabled-upload {
  display: none
}
</style>
